import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb-actions" }
const _hoisted_3 = {
  key: 0,
  class: "msg"
}
const _hoisted_4 = {
  key: 1,
  class: "msg error"
}
const _hoisted_5 = {
  key: 2,
  class: "msg"
}
const _hoisted_6 = {
  key: 3,
  class: "dashboard-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "selection-bar"
}
const _hoisted_8 = { class: "selection-info" }
const _hoisted_9 = { class: "selection-count" }
const _hoisted_10 = { class: "selection-actions" }
const _hoisted_11 = { class: "tbl" }
const _hoisted_12 = { class: "select-col" }
const _hoisted_13 = ["checked", "title"]
const _hoisted_14 = { class: "header-content" }
const _hoisted_15 = { class: "header-content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "right"
}
const _hoisted_18 = { class: "search-row" }
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "search-container" }
const _hoisted_21 = { class: "select-col" }
const _hoisted_22 = ["value", "title"]
const _hoisted_23 = { class: "mono" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "owner-role" }
const _hoisted_26 = { class: "owner-name" }
const _hoisted_27 = { class: "owner-id" }
const _hoisted_28 = {
  key: 1,
  class: "actions right"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["colspan"]
const _hoisted_32 = {
  key: 0,
  class: "pagination-controls"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "pagination-jump" }
const _hoisted_36 = ["max"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 4,
  class: "modal-mask"
}
const _hoisted_40 = { class: "modal" }
const _hoisted_41 = { style: {"margin":"6px 0 18px"} }
const _hoisted_42 = { class: "modal-actions" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]

import axios from "@/axiosInstance";
import dayjs from "dayjs";
import { ArchiveRestore as ArchiveRestoreIcon, X as XIcon, ChevronDown as ChevronDownIcon, ChevronUp as ChevronUpIcon } from "lucide-vue-next";
import { computed, inject, onMounted, ref, watch, type Ref } from "vue";
import { RouterLink } from "vue-router";
import { useToast } from "vue-toast-notification";
import NotificationBell from "./NotificationBell.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { 
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight
} from "@fortawesome/free-solid-svg-icons";

const itemsPerPage = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'ArchivedDevices',
  setup(__props) {

const toast = useToast();

const isDesktop = inject<Ref<boolean>>("isDesktop")!;
const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;
const showCrumbBell = computed(
  () => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value)
);

const loading = ref(true);
const error = ref<string | null>(null);
const archived = ref<any[]>([]);

const searchQuery = ref("");
const currentPage = ref(1);
const currentPageInput = ref(1);

const sortBy = ref("updatedAt");
const sortOrder = ref<"asc" | "desc">("desc");

const toggleSort = (key: string) => {
  if (sortBy.value === key) {
    sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
  } else {
    sortBy.value = key;
    sortOrder.value = "asc";
  }
};

watch(currentPage, (val) => {
  currentPageInput.value = val;
});

const selectedIds = ref<number[]>([]);

const isAllSelected = computed(() => {
  if (paginatedArchived.value.length === 0) return false;
  return paginatedArchived.value.every((d) => selectedIds.value.includes(d.id));
});

function toggleSelectAll() {
  if (isAllSelected.value) {
    const pageIds = paginatedArchived.value.map((d) => d.id);
    selectedIds.value = selectedIds.value.filter((id) => !pageIds.includes(id));
  } else {
    paginatedArchived.value.forEach((d) => {
      if (!selectedIds.value.includes(d.id)) {
        selectedIds.value.push(d.id);
      }
    });
  }
}

watch(searchQuery, () => {
  currentPage.value = 1;
});

const filteredArchived = computed(() => {
  if (!searchQuery.value) return archived.value;
  const q = searchQuery.value.toLowerCase();
  return archived.value.filter((d) => {
    return (
      d.id.toString().toLowerCase().includes(q) ||
      (d.name && d.name.toLowerCase().includes(q)) ||
      (d.status && d.status.toLowerCase().includes(q))
    );
  });
});

const sortedArchived = computed(() => {
  const result = [...filteredArchived.value];
  return result.sort((a, b) => {
    let valA = a[sortBy.value];
    let valB = b[sortBy.value];

    if (sortBy.value === "updatedAt") {
      valA = valA ? new Date(valA).getTime() : 0;
      valB = valB ? new Date(valB).getTime() : 0;
    }

    if (valA < valB) return sortOrder.value === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder.value === "asc" ? 1 : -1;
    return 0;
  });
});

const paginatedArchived = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  return sortedArchived.value.slice(start, start + itemsPerPage);
});

const totalPages = computed(() => {
  return Math.ceil(filteredArchived.value.length / itemsPerPage);
});

const jumpToPage = () => {
  let p = parseInt(String(currentPageInput.value));
  if (isNaN(p)) {
    currentPageInput.value = currentPage.value;
    return;
  }
  if (p < 1) p = 1;
  if (p > totalPages.value) p = totalPages.value;
  currentPage.value = p;
  currentPageInput.value = p;
};

/* ─── stato utente ─── */
const me = ref<any>({});
const isAdmin = computed(() => !!me.value?.is_admin);

function ownerDisplayName(d: any) {
  const u = d.user || {};
  // scegli l’ordine che preferisci: name → username → email → fallback
  return u.name || u.username || u.email || "utente";
}

async function fetchMe() {
  try {
    const { data: user } = await axios.get("/auth/me", {
      withCredentials: true,
    });
    me.value = user;
  } catch (e: any) {
    // se fallisce, mostro un messaggio e continuo (la pagina mostrerà "nessun device")
    error.value = e?.response?.data?.details || "Errore nel recupero utente";
  }
}

async function loadArchived() {
  loading.value = true;
  error.value = null;
  try {
    const { data } = await axios.get("/devices/get-all-graphs", {
      params: { archived: true, all: true }, // <-- admin: tutti gli archiviati
      withCredentials: true,
    });
    archived.value = Array.isArray(data) ? data : [];
  } catch (e: any) {
    error.value = e?.response?.data?.details || "Errore nel caricamento";
  } finally {
    loading.value = false;
  }
}

/* ---------- Ripristino (unarchive) ---------- */
const showRestoreModal = ref(false);
const isBulkRestore = ref(false);
const selectedDevice = ref<any | null>(null);
const restoreLoading = ref(false);

function openRestoreModal(d: any) {
  selectedDevice.value = d;
  isBulkRestore.value = false;
  showRestoreModal.value = true;
}

function openBulkRestoreModal() {
  isBulkRestore.value = true;
  if (selectedIds.value.length === 1) {
    selectedDevice.value = archived.value.find((d) => d.id === selectedIds.value[0]);
  }
  showRestoreModal.value = true;
}

function cancelRestore() {
  showRestoreModal.value = false;
  isBulkRestore.value = false;
  selectedDevice.value = null;
}

async function confirmRestore() {
  if (isBulkRestore.value) {
    await confirmBulkRestore();
    return;
  }
  if (!selectedDevice.value) return;

  restoreLoading.value = true;
  try {
    // endpoint che setta is_archived = false
    await axios.post(
      `/devices/${selectedDevice.value.id}/restore`,
      { is_archived: false },
      { withCredentials: true }
    );

    // aggiorno la lista locale
    archived.value = archived.value.filter(
      (d) => d.id !== selectedDevice.value!.id
    );

    // Notifica chi ascolta (es. DevicesList) di ricaricare
    window.dispatchEvent(
      new CustomEvent("graph-restored", { detail: selectedDevice.value.id })
    );

    toast.success(
      `Device ${
        selectedDevice.value.name || selectedDevice.value.id
      } ripristinato`,
      { position: "top-right", duration: 2000 }
    );

    cancelRestore();
  } catch (e: any) {
    const msg = e?.response?.data?.message || "Errore ripristino";
    toast.error(msg, { position: "top-right", duration: 2500 });
  } finally {
    restoreLoading.value = false;
  }
}

async function confirmBulkRestore() {
  restoreLoading.value = true;
  let successCount = 0;
  let errorCount = 0;

  for (const id of selectedIds.value) {
    try {
      await axios.post(
        `/devices/${id}/restore`,
        { is_archived: false },
        { withCredentials: true }
      );
      successCount++;
    } catch (e) {
      errorCount++;
    }
  }

  if (successCount > 0) {
    archived.value = archived.value.filter(
      (d) => !selectedIds.value.includes(d.id)
    );
    toast.success(`${selectedIds.value.length > 1 ? "Dispositivi" : "Dispositivo"} ripristinat${selectedIds.value.length > 1 ? "i" : "o"} con successo`, {
      position: "top-right",
      duration: 3000,
    });
  }

  if (errorCount > 0) {
    toast.error(`Errore durante il ripristino di ${errorCount} dispositivi`, {
      position: "top-right",
      duration: 3000,
    });
  }

  selectedIds.value = [];
  cancelRestore();
  restoreLoading.value = false;
}

/* ---------- util ---------- */
function formatDate(iso?: string) {
  return iso ? dayjs(iso).format("DD/MM/YYYY HH:mm") : "—";
}
function listModules(d: any) {
  return (
    d?.nodes
      ?.map((n: any) => n?.label)
      .filter(Boolean)
      .join(", ") || "—"
  );
}
function getStatusClass(status: string): string {
  const map: Record<string, string> = {
    online: "on",
    offline: "off",
    maintenance: "maintenance",
    error: "error",
  };
  return map[status] || "off";
}

/* -------- lifecycle -------- */
onMounted(async () => {
  await fetchMe();
  if (!isAdmin.value) {
    error.value = "Area riservata agli amministratori";
    toast.error(error.value, { position: "top-right", duration: 3000 });
    loading.value = false;
    return;
  }
  await loadArchived();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Devices archiviati", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(RouterLink), {
          class: "btn-new",
          to: { name: 'Devices' }
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("⤺ Torna ai devices", -1)
          ]))]),
          _: 1
        }),
        (showCrumbBell.value)
          ? (_openBlock(), _createBlock(NotificationBell, {
              key: 0,
              placement: "header"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Caricamento…"))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
        : (!archived.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Nessun device archiviato"))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_Transition, { name: "slide-fade" }, {
                default: _withCtx(() => [
                  (selectedIds.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("button", {
                            class: "btn-close-selection",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedIds.value = [])),
                            title: "Annulla selezione"
                          }, [
                            _createVNode(_unref(XIcon))
                          ]),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(selectedIds.value.length) + " selezionati", 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("button", {
                            class: "btn-selection-action restore",
                            onClick: openBulkRestoreModal,
                            title: "Ripristina selezionati"
                          }, [
                            _createVNode(_unref(ArchiveRestoreIcon)),
                            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Ripristina", -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("div", {
                class: "tbl-wrap",
                style: _normalizeStyle({ marginTop: selectedIds.value.length > 0 ? '10px' : '50px' })
              }, [
                _createElementVNode("table", _hoisted_11, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_12, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: isAllSelected.value,
                          onChange: toggleSelectAll,
                          title: isAllSelected.value ? 'Deseleziona tutti i device' : 'Seleziona tutti i device'
                        }, null, 40, _hoisted_13)
                      ]),
                      _createElementVNode("th", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSort('id'))),
                        class: "sortable"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[13] || (_cache[13] = _createTextVNode(" ID ", -1)),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(sortBy.value === 'id' ? (sortOrder.value === 'asc' ? _unref(ChevronUpIcon) : _unref(ChevronDownIcon)) : 'span'), { class: "sort-icon" }))
                        ])
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("th", null, "Nome", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("th", null, "Status", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "Moduli", -1)),
                      _createElementVNode("th", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSort('updatedAt'))),
                        class: "sortable"
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[14] || (_cache[14] = _createTextVNode(" Last Update ", -1)),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(sortBy.value === 'updatedAt' ? (sortOrder.value === 'asc' ? _unref(ChevronUpIcon) : _unref(ChevronDownIcon)) : 'span'), { class: "sort-icon" }))
                        ])
                      ]),
                      (isAdmin.value)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Proprietario"))
                        : _createCommentVNode("", true),
                      (isAdmin.value)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_17))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_18, [
                      _createElementVNode("td", {
                        colspan: isAdmin.value ? 8 : 6
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                            type: "text",
                            placeholder: "Cerca per ID, Nome o Status...",
                            class: "search-input"
                          }, null, 512), [
                            [_vModelText, searchQuery.value]
                          ])
                        ])
                      ], 8, _hoisted_19)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedArchived.value, (d, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: d.id,
                        class: _normalizeClass(i % 2 && 'alt')
                      }, [
                        _createElementVNode("td", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: d.id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedIds).value = $event)),
                            title: selectedIds.value.includes(d.id) ? 'Deseleziona questo device' : 'Seleziona questo device'
                          }, null, 8, _hoisted_22), [
                            [_vModelCheckbox, selectedIds.value]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(d.id), 1),
                        _createElementVNode("td", null, _toDisplayString(d.name || "—"), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-dot", getStatusClass(d.status)])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(d.status || "—"), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(listModules(d)), 1),
                        _createElementVNode("td", null, _toDisplayString(formatDate(d.updatedAt)), 1),
                        (isAdmin.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["owner-badge", d.user?.is_admin ? 'admin' : 'user'])
                              }, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(d.user?.is_admin ? "Admin" : "User"), 1),
                                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "owner-sep" }, "•", -1)),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(ownerDisplayName(d)), 1),
                                _createElementVNode("span", _hoisted_27, "(#" + _toDisplayString(d.user?.id ?? d.user_id) + ")", 1)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true),
                        (isAdmin.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                              (selectedIds.value.length === 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "restore-icon",
                                    title: "Ripristina",
                                    onClick: ($event: any) => (openRestoreModal(d))
                                  }, [
                                    _createVNode(_unref(ArchiveRestoreIcon))
                                  ], 8, _hoisted_29))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128)),
                    (searchQuery.value && !filteredArchived.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                          _createElementVNode("td", {
                            colspan: isAdmin.value ? 8 : 7,
                            class: "msg-row",
                            style: {"text-align":"center","padding":"24px","color":"#666","background":"#fff"}
                          }, " Nessun risultato trovato per \"" + _toDisplayString(searchQuery.value) + "\" ", 9, _hoisted_31)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 4), [
                [_vShow, archived.value.length]
              ]),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("button", {
                      class: "btn-pagination",
                      disabled: currentPage.value === 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (currentPage.value = 1)),
                      title: "Vai alla prima pagina"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesLeft) }, null, 8, ["icon"])
                    ], 8, _hoisted_33),
                    _createElementVNode("button", {
                      class: "btn-pagination",
                      disabled: currentPage.value === 1,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (currentPage.value--)),
                      title: "Vai alla pagina precedente"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleLeft) }, null, 8, ["icon"])
                    ], 8, _hoisted_34),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, "Pagina", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentPageInput).value = $event)),
                        onKeyup: _withKeys(jumpToPage, ["enter"]),
                        onBlur: jumpToPage,
                        min: "1",
                        max: totalPages.value,
                        class: "jump-input"
                      }, null, 40, _hoisted_36), [
                        [_vModelText, currentPageInput.value]
                      ]),
                      _createElementVNode("span", null, "di " + _toDisplayString(totalPages.value), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn-pagination",
                      disabled: currentPage.value === totalPages.value,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (currentPage.value++)),
                      title: "Vai alla pagina successiva"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAngleRight) }, null, 8, ["icon"])
                    ], 8, _hoisted_37),
                    _createElementVNode("button", {
                      class: "btn-pagination",
                      disabled: currentPage.value === totalPages.value,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (currentPage.value = totalPages.value)),
                      title: "Vai all'ultima pagina"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faAnglesRight) }, null, 8, ["icon"])
                    ], 8, _hoisted_38)
                  ]))
                : _createCommentVNode("", true)
            ])),
    (showRestoreModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h3", null, _toDisplayString(isBulkRestore.value ? 'Ripristina devices selezionati' : 'Ripristina device'), 1),
            _createElementVNode("p", _hoisted_41, [
              (selectedIds.value.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Vuoi ripristinare i ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(selectedIds.value.length), 1),
                    _cache[21] || (_cache[21] = _createTextVNode(" dispositivi selezionati? ", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[22] || (_cache[22] = _createTextVNode(" Vuoi ripristinare il device ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(selectedDevice.value?.name || selectedDevice.value?.id || (selectedIds.value.length === 1 ? selectedIds.value[0] : '')), 1),
                    _cache[23] || (_cache[23] = _createTextVNode("? ", -1))
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                disabled: restoreLoading.value,
                onClick: confirmRestore
              }, "OK", 8, _hoisted_43),
              _createElementVNode("button", {
                disabled: restoreLoading.value,
                onClick: cancelRestore
              }, " Annulla ", 8, _hoisted_44)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})